import { get } from 'lodash';
import React from 'react';
import { getLocalstorageToken } from 'src/context/AuthHelper';
import EigenmittelSkizzeEmob, { getFormStrucEigenmittelSkizzeEmob } from './EigenmittelSkizzeEmob';

// import schemas
import Schema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = Schema.attributes;

export const GetEigenmittelSkizzeEmob = (application: any, hasCommentAusgabenUndFinanzierung?: boolean) => {
	const OrgaStruc = [
		{
			label: get(application, P.Antragstellende_Organisa_0074063902_licher_Name_Der_Organisation.path, `Antragsteller`),
			content: (
				<>
					<EigenmittelSkizzeEmob
						kostentraeger='Antragsteller'
						unternehmenId={get(getLocalstorageToken(), 'organisationId')}
						hasComment={hasCommentAusgabenUndFinanzierung}
					/>
				</>
			),
			formStruc: getFormStrucEigenmittelSkizzeEmob(application, get(getLocalstorageToken(), 'organisationId')),
		},
	];
	const PartnerStruc = get(application, P.Verbundpartner.path, []).map((ele: any, i: number) => {
		return {
			label: get(
				ele,
				P.Verbundpartner.schema.attributes.Verbundpartner.schema.attributes.Geschaeftsbezogene_Daten_Name_Der_Organisation.path.slice(
					P.Verbundpartner.path.length + 1,
				),
				`Verbundpartner ${i + 1}`,
			),
			content: (
				<EigenmittelSkizzeEmob
					kostentraeger='Verbundpartner'
					unternehmenId={get(ele, 'Verbundpartner.id')}
					hasComment={hasCommentAusgabenUndFinanzierung}
				/>
			),
			formStruc: getFormStrucEigenmittelSkizzeEmob(application, get(ele, 'Verbundpartner.id')),
		};
	});

	return [...OrgaStruc, ...PartnerStruc];
};
